/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const InvoiceStatus = {
    NEW: 'NEW',
    SENT: 'SENT',
    SHIPMENT: 'SHIPMENT',
    REJECTED: 'REJECTED',
    CANCELLED: 'CANCELLED',
    DISCARDED: 'DISCARDED',
    ACCEPTED: 'ACCEPTED',
    INVENTORY: 'INVENTORY',
    RESTORATION: 'RESTORATION'
} as const;
export type InvoiceStatus = typeof InvoiceStatus[keyof typeof InvoiceStatus];

